// @ts-check
import moment from "moment";
import lastSelectableLodgingDay from "../constants/lastSelectableLodgingDay";

export default function validDates(startDate, endDate) {
  const isValid = Boolean(
    startDate &&
    endDate &&
    startDate !== endDate &&
    // The number of nights is less than 31
    moment(endDate).diff(startDate, "days") < 31 &&
    // The start date is today or in the future
    moment(startDate).isSameOrAfter(moment(), "day") &&
    // The selected dates are less than 16 months out
    moment(startDate).isBefore(lastSelectableLodgingDay) &&
    moment(endDate).isSameOrBefore(lastSelectableLodgingDay),
  );

  return isValid;
}



// WEBPACK FOOTER //
// ./assets/shared/utils/validDates.js